export default "__VITE_ASSET__COeev2Do__"